import { mountReact } from "../mountReact.jsx";
import WishlistGrid from "../components/WishlistGrid.jsx";

function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

window.addEventListener('load', function async() {
  waitForElm('.instafeed-new-layout-wrapper').then((elm) => {
    elm.addEventListener('click', function (event) {
      if (event.target.className === 'instafeed-new-layout-wrapper') {
        window.location.href = "https://www.instagram.com/mondoluce_lighting/"
      }
    })
  });
})

mountReact("#wishlist-react-root", WishlistGrid);
